import { useSelector } from "react-redux";
import { config } from "../lib/config";
import { selectCompany } from "../store/slices/authSlice";

export const useGetCompanyUrl = (): string => {
  const company = useSelector(selectCompany);
  const baseUrl = config.kraftvynUrl;
  const companyId = company === "Enkla" ? "ee" : "dk";
  return `${baseUrl}/${companyId}`;
};
